import { render, staticRenderFns } from "./SihaoMemberList.vue?vue&type=template&id=610569ec&scoped=true&"
import script from "./SihaoMemberList.vue?vue&type=script&lang=js&"
export * from "./SihaoMemberList.vue?vue&type=script&lang=js&"
import style0 from "./SihaoMemberList.vue?vue&type=style&index=0&id=610569ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610569ec",
  null
  
)

export default component.exports